import { useRouteMatch } from "react-router-dom";

export const usePath = () => {
  const { url } = useRouteMatch();
  let path = url.endsWith("/") ? url.slice(0, -1) : url;
  let absolute = path.startsWith("/") ? path : `/${path}`;
  let relative = absolute.substring(1);

  return {
    absolute: {
      current: absolute,
      parent: absolute.split("/").slice(0, -1).join("/"),
    },
    relative: {
      current: relative,
      parent: relative.split("/").slice(0, -1).join("/"),
    },
    success: absolute.concat("/success"),
  };
};

export default usePath;
